/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ConfirmUserParams,
  MicrosoftAspNetCoreMvcProblemDetails,
  RequestChangePasswordRequest,
  RequestLoginRequest,
  RequestRefreshTokenRequest,
  RequestRegisterUserRequest,
  RequestResetPasswordRequest,
  RequestSendPasswordResetEmailRequest,
  RequestUpdatePhoneNumberRequest,
  RequestUpdateUserRequest,
  RequestUpdateVideoLanguageRequest,
  RequestUserConfirmationSignature,
  RequestUsersCheckPasswordStrengthRequest,
  RequestUsersOtpLoginRequest,
  ResponseCreateUnconfirmedUserResponse,
  ResponseLogoutResponse,
  ResponsePhaseTwoPasswordStatusResponse,
  ResponseUserPreferenceResponse,
  ResponseUserResponse,
  SendEmailVerificationParams,
  SetUserCurrentMoodsPayload,
  SetUserPreferencesPayload,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Users<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Users
   * @name ChangeUserPassword
   * @summary API to allow a user to change their password (Auth policies: ClientOrExpertOrSupportOrHostPolicy)
   * @request POST:/api/v2/users/change-user-password
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  changeUserPassword = (data: RequestChangePasswordRequest, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v2/users/change-user-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name CheckPasswordStrength
   * @summary Checks if a password is compromised/weak based on known data breaches
   * @request POST:/api/v2/users/passwords/strength
   * @secure
   * @response `200` `void` OK
   */
  checkPasswordStrength = (data: RequestUsersCheckPasswordStrengthRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/api/v2/users/passwords/strength`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags UserConfirmation
   * @name ConfirmUser
   * @summary Handles the user email verification link that completes a legacy registration (Auth policies: UserConfirmationLinkPolicy)
   * @request PUT:/api/v2/users/confirm-user
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  confirmUser = (query: ConfirmUserParams, data: RequestUserConfirmationSignature, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v2/users/confirm-user`,
      method: "PUT",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
 * No description
 *
 * @tags Users
 * @name GetPhaseTwoPasswordStatus
 * @summary Reports whether the signed-in user's Keycloak account has a password credential, so
the profile knows whether to offer a password change. Phase Two sessions only.
Requires the Client or Expert role. (Auth policies: ClientOrExpertOrSupportOrHostPolicy, ClientOrExpertPolicy)
 * @request GET:/api/v2/users/phase-two/password-status
 * @secure
 * @response `200` `ResponsePhaseTwoPasswordStatusResponse` OK
 * @response `401` `void` Unauthorized
 * @response `403` `void` Forbidden
 */
  getPhaseTwoPasswordStatus = (params: RequestParams = {}) =>
    this.http.request<ResponsePhaseTwoPasswordStatusResponse, void>({
      path: `/api/v2/users/phase-two/password-status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetUserCurrentMoods
   * @summary  (Auth policies: ClientOrExpertOrSupportOrHostPolicy)
   * @request GET:/api/v2/users/currentMoods
   * @secure
   * @response `200` `(ResponseUserPreferenceResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getUserCurrentMoods = (params: RequestParams = {}) =>
    this.http.request<ResponseUserPreferenceResponse[], void>({
      path: `/api/v2/users/currentMoods`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetUserPreferences
   * @summary Returns the current user's preferences (Auth policies: ClientOrExpertOrSupportOrHostPolicy)
   * @request GET:/api/v2/users/preferences
   * @secure
   * @response `200` `(ResponseUserPreferenceResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getUserPreferences = (params: RequestParams = {}) =>
    this.http.request<ResponseUserPreferenceResponse[], void>({
      path: `/api/v2/users/preferences`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name GetUserProfileV2
   * @summary Once authorized to get the user's details (Auth policies: ClientOrExpertOrSupportOrHostPolicy)
   * @request GET:/api/v2/users/profile
   * @secure
   * @response `200` `ResponseUserResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getUserProfileV2 = (params: RequestParams = {}) =>
    this.http.request<ResponseUserResponse, void>({
      path: `/api/v2/users/profile`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name LoginV2
   * @summary Login method - provide user name and password to this method and returns JWT access token
   * @request POST:/api/v2/users/login
   * @secure
   * @response `200` `void` OK
   */
  loginV2 = (data: RequestLoginRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/api/v2/users/login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
 * No description
 *
 * @tags Users
 * @name Logout
 * @summary Logs the user out by revoking the refresh token and clearing cookies.
When the user signed in via Phase Two (Keycloak), returns a federated logout URL
that the client should redirect to in order to end the IdP session as well.
The post-logout destination is derived from the request's Origin header; the
endpoint deliberately takes no body so that URLs never appear in the payload
(the WAF rejects request bodies containing off-domain URLs). (Auth policies: ClientOrExpertOrSupportOrHostPolicy)
 * @request POST:/api/v2/users/logout
 * @secure
 * @response `200` `ResponseLogoutResponse` OK
 * @response `401` `MicrosoftAspNetCoreMvcProblemDetails` Unauthorized
 * @response `403` `void` Forbidden
 */
  logout = (params: RequestParams = {}) =>
    this.http.request<ResponseLogoutResponse, MicrosoftAspNetCoreMvcProblemDetails | void>({
      path: `/api/v2/users/logout`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name LogoutAll
   * @summary  (Auth policies: ClientOrExpertOrSupportOrHostPolicy)
   * @request POST:/api/v2/users/logout-all
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  logoutAll = (params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v2/users/logout-all`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name OtpLogin
   * @summary Login method - provide user name and password to this method and returns JWT access token
   * @request POST:/api/v2/users/otp-login
   * @secure
   * @response `200` `void` OK
   */
  otpLogin = (data: RequestUsersOtpLoginRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/api/v2/users/otp-login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name RefreshToken
   * @summary Attempt to refresh the current access token
   * @request POST:/api/v2/users/refresh-token
   * @secure
   * @response `200` `void` OK
   */
  refreshToken = (data: RequestRefreshTokenRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/api/v2/users/refresh-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name RegisterUser
   * @summary Register new user
   * @request POST:/api/v2/users/register-user
   * @secure
   * @response `200` `ResponseCreateUnconfirmedUserResponse` OK
   */
  registerUser = (data: RequestRegisterUserRequest, params: RequestParams = {}) =>
    this.http.request<ResponseCreateUnconfirmedUserResponse, any>({
      path: `/api/v2/users/register-user`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name ResetPassword
   * @summary Api to reset password of user after the user has requested a password reset code
   * @request PUT:/api/v2/users/reset-password
   * @secure
   * @response `200` `void` OK
   */
  resetPassword = (data: RequestResetPasswordRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/api/v2/users/reset-password`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name SendEmailVerification
   * @summary Send an email to verify the user's email address
   * @request POST:/api/v2/users/send-email-verification
   * @secure
   * @response `200` `void` OK
   */
  sendEmailVerification = (query: SendEmailVerificationParams, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/api/v2/users/send-email-verification`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name SendPasswordResetEmail
   * @summary API to send a forgot password email
   * @request POST:/api/v2/users/send-password-reset-email
   * @secure
   * @response `200` `void` OK
   */
  sendPasswordResetEmail = (data: RequestSendPasswordResetEmailRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/api/v2/users/send-password-reset-email`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name SetUserCurrentMoods
   * @summary Sets the current user's preferences (Auth policies: ClientOrExpertOrSupportOrHostPolicy)
   * @request POST:/api/v2/users/currentMoods
   * @secure
   * @response `200` `(ResponseUserPreferenceResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  setUserCurrentMoods = (data: SetUserCurrentMoodsPayload, params: RequestParams = {}) =>
    this.http.request<ResponseUserPreferenceResponse[], void>({
      path: `/api/v2/users/currentMoods`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name SetUserPreferences
   * @summary Sets the current user's preferences (Auth policies: ClientOrExpertOrSupportOrHostPolicy)
   * @request POST:/api/v2/users/preferences
   * @secure
   * @response `200` `(ResponseUserPreferenceResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  setUserPreferences = (data: SetUserPreferencesPayload, params: RequestParams = {}) =>
    this.http.request<ResponseUserPreferenceResponse[], void>({
      path: `/api/v2/users/preferences`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Users
 * @name SyncPhaseTwoPhoneNumber
 * @summary Pulls the SMS-verified phone number from Keycloak into our database after a
Keycloak-driven phone change (kc_action). Phase Two sessions only; a legacy
session or a disabled sync flag is a no-op. Requires the Client or Expert role. (Auth policies: ClientOrExpertOrSupportOrHostPolicy, ClientOrExpertPolicy)
 * @request POST:/api/v2/users/phase-two/sync-phone-number
 * @secure
 * @response `200` `void` OK
 * @response `401` `void` Unauthorized
 * @response `403` `void` Forbidden
 */
  syncPhaseTwoPhoneNumber = (params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v2/users/phase-two/sync-phone-number`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UpdateUserPhoneNumber
   * @summary Updates the user's phone number (Auth policies: ClientOrExpertOrSupportOrHostPolicy)
   * @request PUT:/api/v2/users/phone-number
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  updateUserPhoneNumber = (data: RequestUpdatePhoneNumberRequest, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v2/users/phone-number`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UpdateUserV2
   * @summary Update the current user's details (Auth policies: ClientOrExpertOrSupportOrHostPolicy, ClientOrExpertPolicy)
   * @request PUT:/api/v2/users/update-user
   * @secure
   * @response `200` `ResponseUserResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  updateUserV2 = (data: RequestUpdateUserRequest, params: RequestParams = {}) =>
    this.http.request<ResponseUserResponse, void>({
      path: `/api/v2/users/update-user`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Users
   * @name UpdateVideoLanguage
   * @summary Saves the dub and subtitle languages the video player starts on for the current user, on every device (Auth policies: ClientOrExpertOrSupportOrHostPolicy)
   * @request PUT:/api/v2/users/video-language
   * @secure
   * @response `204` `void` No Content
   * @response `400` `MicrosoftAspNetCoreMvcProblemDetails` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  updateVideoLanguage = (data: RequestUpdateVideoLanguageRequest, params: RequestParams = {}) =>
    this.http.request<void, MicrosoftAspNetCoreMvcProblemDetails | void>({
      path: `/api/v2/users/video-language`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
